const fixUpCart = (el) => {
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'upcart');
};

const tryFixUpCart = () => {
    const existing = document.getElementById('upCart');
    if (existing && !existing.hasAttribute('aria-label')) {
        fixUpCart(existing);
        return true;
    }
    return false;
};

if (!tryFixUpCart()) {
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== Node.ELEMENT_NODE) continue;
                
                const target = node.id === 'upCart' 
                    ? node 
                    : node.querySelector('#upCart');
                
                if (target) {
                    fixUpCart(target);
                    observer.disconnect();
                    return;
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}